import { Suspense, useEffect, useRef, useState } from 'react';
import { Canvas } from '@react-three/fiber';

/**
 * Full-bleed WebGL layer for a section. Mounts Canvas only when the section is near/in view.
 */
export default function SectionThreeCanvas({
  children,
  camera = { position: [0, 0, 7], fov: 42 },
  dpr = [1, 1.5],
  className = '',
}) {
  const rootRef = useRef(null);
  const [active, setActive] = useState(false);

  useEffect(() => {
    const el = rootRef.current;
    if (!el || typeof IntersectionObserver === 'undefined') {
      setActive(true);
      return undefined;
    }
    const io = new IntersectionObserver(
      ([e]) => setActive(e.isIntersecting),
      { root: null, rootMargin: '180px', threshold: 0 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <div
      ref={rootRef}
      className={`pointer-events-none absolute inset-0 z-0 overflow-hidden motion-reduce:hidden ${className}`}
      aria-hidden
    >
      {active ? (
        <Suspense fallback={null}>
          <Canvas
            className="h-full w-full"
            camera={camera}
            gl={{
              alpha: true,
              antialias: true,
              powerPreference: 'high-performance',
            }}
            dpr={dpr}
          >
            {children}
          </Canvas>
        </Suspense>
      ) : null}
    </div>
  );
}
